import React, { useContext } from "react";
import countries from "lib/countries";

const QuizContext = React.createContext();

const Provider = ({ country, children }) => {
  return (
    <QuizContext.Provider value={{ country }}>{children}</QuizContext.Provider>
  );
};
Provider.displayName = "QuizProvider";

export const Consumer = QuizContext.Consumer;

export const useUsersCountry = () => {
  const { country } = useContext(QuizContext);

  return countries.includes(country) ? country : "US";
};

// export const useUsersOriginalCountry = () => {
//   const { country } = useContext(QuizContext);

//   return country;
// };

export default Provider;
